import React, { CSSProperties, FormEvent, FormEventHandler, KeyboardEvent, KeyboardEventHandler } from 'react'
import classes from './Select.module.css'

type InputType = {
	type?: string
	value?: string
	oninput?: (str: string) => void
	checked?:boolean
	placeholder?: string
	title?: string
	style?: CSSProperties
	onChange?: () => void
	keyDown?: (e: KeyboardEvent<HTMLInputElement>) => void
}

function InputCheck({ type = 'text', value = '', oninput = () => {}, placeholder = '', title = '', style = {}, keyDown,checked=false,onChange }: InputType) {
	return (
		<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '15px' }}>
			<label className={classes.inp_label}>{title}</label>
			<input
				type={type}
				placeholder={placeholder}
				style={style}
				value={value}
				className={classes.input}
				onInput={(event: FormEvent<HTMLInputElement>) => {
					oninput(event.currentTarget.value)
				}}
				checked={checked}
				onChange={onChange}
				onKeyDown={keyDown ? keyDown : (event: KeyboardEvent<HTMLInputElement>) => {}}
			/>
		</div>
	)
}

export default InputCheck
